<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form
            :model="model"
            :afdelingen="afdelingen"
            :teelten="teelten"
            :isEditing="true"
            @save-item="updateItem">
        </item-form>

        <b-modal title="Wijzigen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Teelt werd niet gewijzigd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/afdelingteelt';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                afdelingen: [],
                teelten: [],
                model: { },
            };
        },
        created () {
            api.getDetailAfdelingteelt(this.$route.params.id).then((response) => {
                this.afdelingen = response.data.afdelingen;
                this.teelten = response.data.teelten;
                this.model = response.data.model;
            });
        },
        methods: {
            updateItem (model) {
                api.updateAfdelingteelt(model).then(() => {
                    this.$router.replace('/beheer/afdelingteelt');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/afdelingteelt/Edit.vue